import * as React from 'react';

type FormProps = {
  className?: string;
  children: React.ReactNode;
  onSubmit: (e: React.FormEvent) => void;
};

const Form: React.FC<FormProps> = ({ children, onSubmit, ...props }) => {
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(e);
      }}
      {...props}
    >
      {children}
    </form>
  );
};

export default Form;
